import { useWindowDimensions } from 'react-native';
import { DimensionsInfo, ORIENTATIONS } from './types';

const useDimensions = (): DimensionsInfo => {
    const { width, height, ...rest } = useWindowDimensions();

    const currentOrientation = width > height ? ORIENTATIONS.LANDSCAPE : ORIENTATIONS.PORTRAIT;

    return {
        isLandscape: width > height,
        aspectRatio: width / height,
        orientation: currentOrientation,
        viewPortWidth: width,
        viewPortHeight: height,
        width,
        height,
        ...rest,
    };
};

export default useDimensions;
